<template>
  <div class="harvest-Plan-View">
        <PageTitle
            imagem="Planejamento.png"
            main="Plano de Moagem e Produção"
            sub=""
        />
       <HarvestPlanViewTable />
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import HarvestPlanViewTable from "./HarvestPlanViewTable";

export default {
  name: "harvestPlanView",
  components: { PageTitle ,HarvestPlanViewTable},
  beforeDestroy(){
    
  }
};
</script>



<style>




</style>